import React, { useMemo } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

function Anchor({ children, ...props }) {
  return (
    <a {...props}>
      {children}
    </a>
  );
}

function Link({ to, exact, className, newTab, title, children }) {
  const [external, cleanUrl] = useMemo(() => {
    const fullUrl = to.startsWith("//") ? `${location.protocol}${to}` : to;

    if (fullUrl.startsWith("http") && URL.canParse(fullUrl)) {
      const url = new URL(fullUrl);

      if (url.host !== location.host) {
        return [true, fullUrl];
      }

      return [false, `${url.pathname}${url.search}`];
    }

    return [false, to];
  }, [to]);

  const Component = external ? Anchor : NavLink;
  const classes = classnames(className);
  const props = { className: classes || undefined, title };

  if (external) {
    props.href = cleanUrl;
    props.rel = "noreferrer nofollow";
    props.target = "_blank";
  } else {
    props.to = cleanUrl;
    props.exact = exact;
    if (newTab) props.target = "_blank";
  }

  return (
    <Component {...props}>
      {children}
    </Component>
  );
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  newTab: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string,
};

Link.defaultProps = {
  exact: false,
  children: null,
  className: null,
  newTab: false,
};

export default Link;
